export default "__VITE_ASSET__D75fV1Nk__"